import React from 'react'

function BoyContent() {
  return (
    <svg
      width={205}
      height={230}
      viewBox="0 0 205 230"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M191.978 37.191c19.142 29.505 13.03 73.731-.398 109.826-13.371 36.046-33.999 63.935-61.027 75.913-26.969 11.976-60.283 8.022-85.766-6.473C19.245 201.957 1.53 176.93.103 153.089c-1.486-23.767 13.371-46.291 30.056-75.223C46.844 48.934 65.47 13.586 96.957 3.274c31.539-10.312 75.879 4.477 95.021 33.917z"
        fill="#F3F5F8"
      />
      <path
        d="M56.797 215.771H43.181a1.365 1.365 0 000 2.73h61.043a1.365 1.365 0 100-2.73H90.608c-8.274 0-14.981-6.707-14.981-14.981v-68.183a1.924 1.924 0 10-3.848 0v68.183c0 8.274-6.708 14.981-14.981 14.981z"
        fill="#737373"
      />
      <path
        d="M82.036 204.662l-9.388-1.533-.8 4.859 9.387 1.533.801-4.859zM128.16 191.619l-5.898 4.543 3.028 3.894 5.898-4.544-3.028-3.893z"
        fill="#DE8E68"
      />
      <path
        d="M99.104 161.74c-.243 1.253 20.854 34.724 22.543 34.724 2.166 0 7.14-3.673 7.14-4.71s-9.502-25.146-9.502-29.217c0-4.071-18.097-11.578-20.181-.797z"
        fill="#C01414"
      />
      <path
        d="M166.177 151.382c0-2.589-38.252-17.885-65.181-17.885-15.737 0-28.613 68.585-28.613 69.767 1.262.369 9.801 1.553 9.801 1.553s21.391-43.456 21.985-46.413c2.154 1.478 29.288 15.519 39.764 15.519 11.482 0 22.244-11.75 22.244-22.541z"
        fill="#D62929"
      />
      <path
        d="M152.537 80.682c7.865-1.332 12.496 6.286 13.476 12.071 4.524 26.715 3.526 54.387.674 56.949-5.037 4.529-32.829.483-36.153-4.73-3.831-6.003-6.893-59.397 22.003-64.29z"
        fill="#4D4D4D"
      />
      <path
        d="M152.058 67.46c.002 1.05 1.814 9.67 5.13 14.71-.625 1.506-7.971 5.9-12.251 3.475-.119-2.78-.698-7.234-1.472-9.728-.774-2.495 4.488-8.812 4.488-8.812l4.105.355z"
        fill="#A4A1A1"
      />
      <path
        d="M141.759 77.78c4.958-.84 7.874-8.033 6.513-16.068-1.361-8.035-6.483-13.869-11.44-13.029-4.958.84-7.873 8.034-6.513 16.069 1.361 8.035 6.483 13.868 11.44 13.028z"
        fill="#B3B3B3"
      />
      <path
        d="M132.773 39.729c3.762-.637 6.638 1.344 9.148 2.144 4.278 1.376 13.625-.557 14.835 6.59.864 5.105-.786 6.784-.382 9.167.23 1.361.658 1.813 1.12 4.536.605 3.574-2.698 5.883-4.578 6.202-6.669 1.129-9.632-6.183-10.647-7.825-4.117-6.654-9.444-4.877-11.154-4.587-.596 1.676-.761 4.855-.761 4.855-5.422 1.394-8.035-5.377-8.035-8.538 0-5.226 2.613-6.56 4.181-7.84 2.463-2.012 2.341-4.038 6.273-4.704z"
        fill="#0D0D0D"
      />
      <path
        d="M147.608 66.638a3.2 3.2 0 002.63-3.683 3.2 3.2 0 00-3.696-2.613 3.2 3.2 0 00-2.63 3.684 3.2 3.2 0 003.696 2.612zM147.297 112.037c-.34 1.108-1.954 7.158-1.431 12.321-2.738-.587-29.232-7.478-33.848-6.696-9.062 1.534-10.966 4.832-10.735 6.194.432 2.552 11.488.33 13.171.92 1.683.59 35.46 15.175 39.221 14.538 3.762-.637 10.457-18.225 10.136-22.196"
        fill="#B3B3B3"
      />
      <path
        d="M160.739 90.671c8.794 2.502 7.75 29.145 4.017 29.952-3.733.807-18.621-4.023-20.022-6.061-1.4-2.039 7.135-26.415 16.005-23.89z"
        fill="#646363"
      />
      <path d="M114.96 129.553H26.52v3.451h88.44v-3.451z" fill="#737373" />
      <path
        d="M81.537 209.016l-10.431-1.778-16.395 4.532-.691 2.178 25.933 4.16 1.584-9.092zM129.983 194.054l-6.062 5.828-6.487 15.855 1.071 1.531 16.643-17.816-5.165-5.398z"
        fill="#0D0D0D"
      />
      <path
        d="M127.445 183.119c0-5.851 5.001-10.452 10.831-9.966l6.138.512a9.94 9.94 0 001.905-.024l6.513-.704c5.871-.634 11.01 3.93 11.074 9.835l.27 25.172c.06 5.565-4.434 10.108-9.999 10.108h-16.732c-5.523 0-10-4.478-10-10v-24.933z"
        fill="#C4C4C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M131.826 65.347a.32.32 0 01.137.432l-.089.165c-.16.29-.408.739-.509 1.193-.06.271-.054.497.021.668.069.154.219.314.57.415a.32.32 0 11-.178.616c-.492-.141-.816-.408-.977-.771-.155-.348-.136-.73-.061-1.066.123-.56.434-1.118.588-1.394l.066-.121a.32.32 0 01.432-.137zM134.805 69.066a.321.321 0 01.129.435c-.174.32-.434.658-.716.929-.27.26-.607.504-.943.56a.32.32 0 01-.105-.632c.136-.023.356-.151.604-.39.237-.228.456-.514.596-.773a.321.321 0 01.435-.129z"
        fill="#1F161E"
      />
      <ellipse
        rx={0.464}
        ry={0.929}
        transform="matrix(-1 0 0 1 136.043 64.701)"
        fill="#0D0D0D"
      />
      <path
        d="M137.896 69.347c-1.026 0-1.858-.416-1.858-.929 0-.513.832-.929 1.858-.929 1.026 0 1.858.416 1.858.93 0 .512-.832.928-1.858.928z"
        fill="#FA9E9F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.237 105.394a2.614 2.614 0 013.551 1.023l10.083 18.245c.092.166.267.27.457.27h20.627a2.613 2.613 0 110 5.227H93.328a5.75 5.75 0 01-5.032-2.969l-10.083-18.244a2.614 2.614 0 011.024-3.552z"
        fill="#333"
      />
      <g clipPath="url(#prefix__clip0)" fill="#E5E5E5">
        <path d="M64.761 61.601c2.124-.158 7.215.99 11.968.645 2.767-.199 3.623-1.655 5.792-3.312 10.318-7.828 9.738-3.424 11.044-4.299.424 1.07 3.765 10.21 4.503 12.026.66 1.675.323 3.025-1.088 4.065-2.155 1.58-4.279 3.254-6.574 4.662-5.865 3.6-10.973 3.705-17.378 4.027-1.697.081-2.914-.71-3.558-2.307-3.002-7.492-4.472-14.78-4.709-15.507z" />
        <path d="M102.036 61.299c1.996 2.133 2.565 2.412 1.408 2.924-.701.313-1.448.549-2.195.784-.533.15-.781-.072-.787-.654-.009-.827.013-1.652.004-2.479-1.107-.527-1.686-1.816-1.408-2.985.058-.243.138.05-1.59-4.262-4.75 3.591-8.118 6.142-13.93 10.523-1.547 1.173-3.33 1.802-5.317 1.92-6.818.384-13.667.768-20.5 1.137-.932.045-1.611-.528-1.697-1.403-.069-.676.324-1.091.81-1.442a6689.201 6689.201 0 0015.66-11.782c1.729-1.32 3.664-2.036 5.88-2.16 6.711-.373 13.437-.761 20.163-1.149.917-.061 1.456.217 1.738.869.329.73.168 1.383-.623 1.846-.562.334-.62.699-.338 1.29 1.237 2.688 1.171 3.62 2.079 4.186.663.435.97 2.022.643 2.837z" />
      </g>
      <g clipPath="url(#prefix__clip1)">
        <path
          d="M63.772 125.47H38.034c-.795 0-1.444.658-1.444 1.464v1.238c0 .811.65 1.464 1.444 1.464h25.733l-.016-.016a3.019 3.019 0 01.02-4.15z"
          fill="#B3B3B3"
        />
        <path
          d="M63.312 126.087H49.558c-.8 0-1.445.658-1.445 1.464 0 .811.65 1.464 1.445 1.464h13.754a3.024 3.024 0 010-2.928zM60.632 125.36H50.577c-.894 0-1.616-.869-1.616-1.944 0-1.074.722-1.943 1.616-1.943h10.055c-.77 1.074-.8 2.654-.073 3.776l.073.111z"
          fill="#D8D8D8"
        />
        <path
          d="M48.962 123.416c0-1.074.738-1.943 1.653-1.943h10.21c.047 0 .089-.048.084-.1 0-.053-.037-.101-.084-.101H44.63c-1.008 0-1.824.959-1.824 2.144s.816 2.144 1.824 2.144h16.196c.047 0 .084-.043.084-.1 0-.058-.037-.101-.084-.101H50.62c-.915 0-1.658-.869-1.658-1.943z"
          fill="#969696"
        />
        <path
          d="M58.882 122.426h-1.117c-.24 0-.437.079-.437.179v.016h1.554v-.195z"
          fill="#184655"
        />
        <path
          d="M59.834 122.879c0-.247-.291-.447-.65-.447H57.75c.27 0 .494.152.494.342l-.005 4.809.79-.617.805.617v-4.704z"
          fill="#969696"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path
            fill="#fff"
            transform="rotate(-44.351 109.516 -34.626)"
            d="M0 0h43.058v31.967H0z"
          />
        </clipPath>
        <clipPath id="prefix__clip1">
          <path
            fill="#fff"
            transform="translate(36.59 121.272)"
            d="M0 0h27.182v8.364H0z"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default React.memo(BoyContent)
